export default __webpack_public_path__ + "static/media/bg.cce1f555.svg";